"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// THIS FILE IS GENERATED
exports.default = "0.3.6";
